'use client';

import Image from 'next/image';

import { useLayout } from '@/context/layout-context';
import { Paths } from '@/utils/paths';

import { SolutionsMenuItem } from './SolutionsMenuItem';

export function SolutionsMenu() {
  const { content } = useLayout();

  const { storeLogoUrl, benefitsLogoUrl, networkLogoUrl } = content.topbar;

  const {
    solutionsStoreDescription,
    solutionsBenefitDescription,
    solutionsNetworkDescription,
  } = content.mobileNav;

  return (
    <div className="flex flex-col items-start gap-7">
      <SolutionsMenuItem href={Paths.STORES} className="text-store-primary">
        <Image src={storeLogoUrl} height={24} width={100} alt="Store" />

        <span className="pl-8 text-sm">{solutionsStoreDescription}</span>
      </SolutionsMenuItem>

      <SolutionsMenuItem href={Paths.BENEFITS} className="text-benefit-primary">
        <Image src={benefitsLogoUrl} height={24} width={120} alt="Benefits" />

        <span className="pl-8 text-sm">{solutionsBenefitDescription}</span>
      </SolutionsMenuItem>

      <SolutionsMenuItem href={Paths.NETWORKS} className="text-network-primary">
        <Image src={networkLogoUrl} height={24} width={128} alt="Networks" />

        <span className="pl-8 text-sm">{solutionsNetworkDescription}</span>
      </SolutionsMenuItem>
    </div>
  );
}
